import Page from './index';

export default { path: '/home/tenant/config', component: Page };
